import { useTranslation } from 'react-i18next'
import ShareButtons from 'src/common/components/ShareOffer/ShareButtons'
import { generateShareLink } from 'src/common/components/ShareOffer/utils'
import { AnyToken } from 'src/common/types/models/Tokens'
import useActiveOrDefaultChain from '../../hooks/web3/useActiveOrDefaultChain'
import Icon from '../../ui-kit/Icon/Icon'
import IconButton from '../../ui-kit/IconButton'
import TextField from '../../ui-kit/TextField/TextField'
import { useToastManager } from '../ToastManager/hooks/useToastManager'
import TokenExchangePair from '../TokenExchangePair'

interface ShareOfferProps {
  tokenIn: AnyToken
  tokenOut: AnyToken
  amountIn: Big
  amountOut: Big
  offerId: string
  className?: string
}

const ShareOffer: React.FC<ShareOfferProps> = ({
  tokenIn,
  tokenOut,
  amountIn,
  amountOut,
  offerId,
  className,
}) => {
  const { t } = useTranslation('offersManagement', { keyPrefix: 'offerShare' })
  const chain = useActiveOrDefaultChain()
  const { addToast } = useToastManager()

  const shareLink = generateShareLink(offerId, chain?.name)

  const copyShareLink = () => {
    navigator.clipboard.writeText(shareLink)
    addToast(t('copiedMessage'), {
      type: 'info',
    })
  }

  return (
    <div className={className}>
      <TokenExchangePair
        tokenIn={tokenIn}
        tokenOut={tokenOut}
        amountIn={amountIn}
        amountOut={amountOut}
        className='mb-6'
      />
      <div>
        <div className='flex justify-between mb-1.5'>
          <span className='typo-label2 text-main-accent'>{t('label')}</span>
          <ShareButtons link={shareLink} />
        </div>
        <TextField
          inputProps={{ readOnly: true }}
          hideError
          value={shareLink}
          EndAdornment={
            <IconButton
              hoverBackground='secondary-accent'
              onClick={copyShareLink}
            >
              <Icon name='copy' size={16} />
            </IconButton>
          }
        />
      </div>
    </div>
  )
}

export default ShareOffer
